export const getPrettyAmount = (amount: number, isCurrency = false) =>
  `${new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: amount < 0 ? 6 : 2,
    notation: amount >= 1_000_000 ? "compact" : "standard",
    style: isCurrency ? "currency" : undefined,
    currency: "USD",
  }).format(+amount)}`;
